import { action, atom } from '@reatom/framework'
import { getCurrentWindow } from '@tauri-apps/api/window'
import * as DateF from 'date-fns'

import { Data, Duration } from '@blade/std-lib'

import { PlatformUtil } from '../platform-util'

export class AppVisibleState extends Data.Class<{
  timestamp: Date | undefined
  inactiveDuration: Duration.Duration | undefined
}> {}

export class AppInvisibleState extends Data.Class<{
  timestamp: Date
}> {}

type AppVisibilityState = AppVisibleState | AppInvisibleState

export const appVisibilityAtom = atom<AppVisibilityState>(
  new AppVisibleState({ timestamp: undefined, inactiveDuration: undefined }),
  'appVisibilityAtom',
)
const prevVisibilityAtom = atom<AppVisibilityState | undefined>(
  undefined,
  'prevVisibilityAtom',
)

export const isAppVisibleAtom = atom((ctx) => {
  return ctx.spy(appVisibilityAtom) instanceof AppVisibleState
}, 'isAppVisibleAtom')

const setAppVisibleAction = action((ctx) => {
  const currentState = ctx.get(appVisibilityAtom)
  prevVisibilityAtom(ctx, currentState)

  const invisibleDuration = (() => {
    if (currentState instanceof AppInvisibleState) {
      return Duration.fromInputUnsafe(
        DateF.differenceInMilliseconds(new Date(), currentState.timestamp),
      )
    }
    return undefined
  })()

  appVisibilityAtom(
    ctx,
    new AppVisibleState({
      timestamp: new Date(),
      inactiveDuration: invisibleDuration,
    }),
  )
}, 'setAppVisibleAction')

export const initializeVisibilityAction = action((ctx) => {
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      prevVisibilityAtom(ctx, ctx.get(appVisibilityAtom))
      appVisibilityAtom(ctx, new AppInvisibleState({ timestamp: new Date() }))
      return
    }
    setAppVisibleAction(ctx)
  })

  if (!PlatformUtil.is('tauri')) {
    return
  }

  const appWindow = getCurrentWindow()

  appWindow.onFocusChanged(({ payload: focused }) => {
    if (focused) {
      setAppVisibleAction(ctx)
    }
  })
}, 'initializeVisibilityAction')
